module.exports = __webpack_public_path__ + "img/class.3c607a8b.webp";